/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialExportSummary } from './FinancialExportSummary';
import {
    FinancialExportSummaryFromJSON,
    FinancialExportSummaryFromJSONTyped,
    FinancialExportSummaryToJSON,
    FinancialExportSummaryToJSONTyped,
} from './FinancialExportSummary';
import type { FinancialExportTransaction } from './FinancialExportTransaction';
import {
    FinancialExportTransactionFromJSON,
    FinancialExportTransactionFromJSONTyped,
    FinancialExportTransactionToJSON,
    FinancialExportTransactionToJSONTyped,
} from './FinancialExportTransaction';
import type { FinancialExportTournament } from './FinancialExportTournament';
import {
    FinancialExportTournamentFromJSON,
    FinancialExportTournamentFromJSONTyped,
    FinancialExportTournamentToJSON,
    FinancialExportTournamentToJSONTyped,
} from './FinancialExportTournament';

/**
 * 
 * @export
 * @interface TournamentFinancialsExportResponse
 */
export interface TournamentFinancialsExportResponse {
    /**
     * 
     * @type {FinancialExportTournament}
     * @memberof TournamentFinancialsExportResponse
     */
    tournament?: FinancialExportTournament;
    /**
     * 
     * @type {FinancialExportSummary}
     * @memberof TournamentFinancialsExportResponse
     */
    financials?: FinancialExportSummary;
    /**
     * 
     * @type {Array<FinancialExportTransaction>}
     * @memberof TournamentFinancialsExportResponse
     */
    transactions?: Array<FinancialExportTransaction>;
}

/**
 * Check if a given object implements the TournamentFinancialsExportResponse interface.
 */
export function instanceOfTournamentFinancialsExportResponse(value: object): value is TournamentFinancialsExportResponse {
    return true;
}

export function TournamentFinancialsExportResponseFromJSON(json: any): TournamentFinancialsExportResponse {
    return TournamentFinancialsExportResponseFromJSONTyped(json, false);
}

export function TournamentFinancialsExportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentFinancialsExportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournament': json['tournament'] == null ? undefined : FinancialExportTournamentFromJSON(json['tournament']),
        'financials': json['financials'] == null ? undefined : FinancialExportSummaryFromJSON(json['financials']),
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(FinancialExportTransactionFromJSON)),
    };
}

export function TournamentFinancialsExportResponseToJSON(json: any): TournamentFinancialsExportResponse {
    return TournamentFinancialsExportResponseToJSONTyped(json, false);
}

export function TournamentFinancialsExportResponseToJSONTyped(value?: TournamentFinancialsExportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournament': FinancialExportTournamentToJSON(value['tournament']),
        'financials': FinancialExportSummaryToJSON(value['financials']),
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(FinancialExportTransactionToJSON)),
    };
}

